import { render, staticRenderFns } from "./CommonMessage.vue?vue&type=template&id=a5091b66"
import script from "./CommonMessage.vue?vue&type=script&lang=js"
export * from "./CommonMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports